<template>
    <div class="site-popup">
        <div v-if="site.photos.length" class="featured-image" :style="`background-image:url(${site.photos[0].permalink + '?w=800'});`">
            <div v-if='nudityAvailable(site)' class="featured-attribute shadow">{{ nudityAvailable(site) | ucWords }}</div>
        </div>
        <h2 class="h4 mb-0">{{ site.name }}</h2>
        <h3 class="h6 mt-0"><address>{{ site.location.formatted_locality }}</address></h3>
        <a :class="['btn btn-sm btn-block', {'btn-primary': !site.coming_soon, 'btn-secondary': site.coming_soon}]" :href="`/sites/${site.slug}`">More Info</a>
    </div>
</template>

<script>
import SiteMixins from '@/mixins/SiteMixins';

export default {
    name: 'SitePopup',
    mixins: [
        SiteMixins,
    ],
    props: {
        site: {
            type: Object,
            required: true,
        }
    }
};
</script>

<style lang="scss">
.site-popup {
    .featured-image {
        position: relative;
        width: 260px;
        height: 0;
        padding-top: 67%;
        background-size: cover;
        background-position: center center;
        overflow: initial;
        border-radius: 4px;
        
        .featured-attribute {
            position: absolute;
            font-size: 10px;
            bottom: 15px;
            left: 15px;
            padding: 3px 7px;
            background: white;
            border: $light-gray;
            border-radius: 4px;
            text-transform: uppercase;
            font-weight: bold;
            color: $almost-black;
        }
    }
}
</style>